import { getRefName as e, getSchemaRefName as t } from "./get-ref-name.js";
import { resolve as n } from "@scalar/workspace-store/resolve";
import { isArraySchema as r } from "@scalar/workspace-store/schemas/v3.2/strict/type-guards";
//#region src/schema/helpers/schema-name.ts
var i = (r) => {
	if (!r) return null;
	let i = n.schema(r), a = "$ref" in r ? t(r.$ref) : null;
	if (i.title) return {
		schemaKey: a,
		label: i.title
	};
	if (i.name) return {
		schemaKey: a,
		label: i.name
	};
	if ("$ref" in r) {
		let t = e(r.$ref);
		if (t) return {
			schemaKey: a,
			label: t
		};
	}
	return null;
}, a = (e) => {
	let t = i(e);
	if (t) return t;
	let a = n.schema(e);
	if (r(a) && a.items) {
		let e = i(a.items);
		if (e) return {
			schemaKey: e.schemaKey,
			label: `${e.label}[]`
		};
	}
	return null;
};
//#endregion
export { i as getModelNameFromSchema, a as getModelNameWithArray };

//# sourceMappingURL=schema-name.js.map